import React from 'react'

const ButtonRow =({buttons,visible = true}) => {
    const buttonsElements = buttons.map( button =>
        button.style === 'spacer' ?
        <div></div> :
        <button type="button" className={`btn btn-${button.style}`} onClick={button.action}>{button.label}</button>)
    
    return(
        <li className="comment-buttons" style={{maxWidth: `${buttons.length * 125}px`, marginLeft: 'auto', height: visible ? 'auto' : '0', padding: visible ? '10px' : '0', gridTemplateColumns: `repeat(${buttons.length},1fr)`}}>
            {buttonsElements}
        </li>
    )
}

export default ButtonRow;